{
  "deselectedItem": "{item} niet geselecteerd.",
  "select": "Selecteren",
  "selectedAll": "Alle items geselecteerd.",
  "selectedCount": "{count, plural, =0 {Geen items geselecteerd} one {# item geselecteerd} other {# items geselecteerd}}.",
  "selectedItem": "{item} geselecteerd."
}
